import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, mergeProps as _mergeProps, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a7a7cf98"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-claim__loading" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "spinner" })
], -1))
const _hoisted_3 = ["src"]

import { storeToRefs } from 'pinia';
import { computed, onMounted, ref } from 'vue';
import { appsApi } from '@/api/apiHelpers';
import ClaimCompleteBody from '@/components/ClaimCompleteBody.vue';
import ErrorPage from '@/components/ErrorPage.vue';
import { useClientAnimation } from '@/composables/clientAnimation';
import { trackInstanceView } from '@/lib/telemetry';
import { useClaimStore } from '@/store/claimStore';

export type ClaimProps = {
  id: number;
  fallbackProvider?: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'MClaimComplete',
  props: {
    id: {},
    fallbackProvider: {}
  },
  setup(__props: any) {

const props = __props;

_useCssVars(_ctx => ({
  "cbef350a": (_unref(store).clientColors.themePrimary),
  "4d16a4a6": (loadingBackgroundColorCss.value)
}))



const store = useClaimStore();
// get the reactive ref for composable
const { clientAnimation } = storeToRefs(store);
const {
  x: animationX,
  y: animationY,
  height,
  width,
  playing: showAnimation,
} = useClientAnimation(clientAnimation);
const error = ref<any>();

// NOTE: separate background color from background image css so that color can be overlayed on top of image
const backgroundColorCss = computed(() => {
  return { backgroundColor: store.appBackground.backgroundColor };
});

const backgroundCss = computed(() => {
  const backgroundProps: {
    backgroundImage?: string;
    backgroundRepeat?: string;
    backgroundSize?: string;
  } = {};
  if (store.appBackground.image) {
    // NOTE: The Claim's background image is set here using the store's appBackground.image
    backgroundProps.backgroundImage = `url(${store.appBackground.image})`;
    backgroundProps.backgroundRepeat = 'no-repeat';
    backgroundProps.backgroundSize = 'cover';
  }
  return backgroundProps;
});

const animationSrc = computed(() => {
  if (!store.clientAnimation) {
    return '';
  }
  return store.clientAnimation.source;
});

const animationCss = computed(() => {
  if (!store.clientAnimation) {
    return {
      display: 'none',
    };
  }
  return {
    top: `${animationY.value}px`,
    left: `${animationX.value}px`,
    display: showAnimation.value ? 'block' : 'none',
    width: `${width.value}px`,
    height: `${height.value}px`,
  };
});

const loadingBackgroundColorCss = computed(() => {
  if (store.appBackground.image || store.appBackground.video) {
    // if there's a background image or video, use a slightly transparent background
    return 'hsl(0deg 0% 0% / 80%)';
  }
  // default to black for claims that don't have a background
  return 'black';
});

onMounted(async () => {
  try {
    const instance = await appsApi.getInstance(props.id);
    await store.initialize(instance, props.fallbackProvider);
    trackInstanceView({
      status: store.status,
      isSoldOut: store.isSoldOut,
      analytics: store.analytics,
      app: 'claim',
    });
  } catch (e) {
    console.log('Error initializing claim', e);
    error.value = e;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _mergeProps({ class: "m-claim" }, _ctx.$attrs, { style: backgroundCss.value }), [
      (_unref(store).appBackground.video)
        ? (_openBlock(), _createElementBlock("video", {
            key: 0,
            class: "m-claim__background",
            src: _unref(store).appBackground.video,
            playsinline: "",
            autoplay: "",
            muted: "",
            loop: ""
          }, null, 8, _hoisted_1))
        : _createCommentVNode("", true),
      (Boolean(error.value))
        ? (_openBlock(), _createBlock(ErrorPage, {
            key: 1,
            error: error.value
          }, null, 8, ["error"]))
        : (_unref(store).initializedInstanceData)
          ? (_openBlock(), _createBlock(ClaimCompleteBody, {
              key: 2,
              style: _normalizeStyle(backgroundColorCss.value)
            }, null, 8, ["style"]))
          : (_openBlock(), _createBlock(_Transition, {
              key: 3,
              name: "fade"
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }))
    ], 16),
    (_unref(store).initializedInstanceData && animationSrc.value && _unref(showAnimation))
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "m-claim__animation",
          src: animationSrc.value,
          style: _normalizeStyle(animationCss.value)
        }, null, 12, _hoisted_3))
      : _createCommentVNode("", true)
  ], 64))
}
}

})